class UserQueryKeys {
    constructor(prefix) {
        this.prefix = prefix;
    }
    getCurrentUser() {
        return [this.prefix, 'current'];
    }
}
export default UserQueryKeys;
